if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        // Prefer FFS one-at-a-time lightbox for image + video; keep built-in for 3D model
        try {
          const mediaId = opener && opener.getAttribute('data-media-id');
          const isFfsOpener =
            opener &&
            opener.closest &&
            opener.closest(
              '.product__modal-opener--image, .product__modal-opener--video, .product__modal-opener--external_video'
            );
          if (
            mediaId &&
            isFfsOpener &&
            window.FFSProductLightbox &&
            typeof window.FFSProductLightbox.openFromMediaId === 'function'
          ) {
            const opened = window.FFSProductLightbox.openFromMediaId(mediaId, this);
            if (opened) return;
          }
        } catch (e) {
          /* fall through to built-in */
        }

        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
